module.exports = __webpack_public_path__ + "static/media/icp-logo.b49fb9a0.svg";